module.exports = require("redux");


/*****************
 ** WEBPACK FOOTER
 ** external "redux"
 ** module id = 43
 ** module chunks = 0
 **/